<template>
  <div class="listing-amenities my-2">
    <div
      v-if="mini"
      class="listing-amenities-brief text--secondary"
      style="line-height: 1rem"
    >
      <span v-for="(item, index) in amenities" :key="item" class="text-caption">
        <v-icon small class="mr-1">{{ getAmenityIcon(item) }}</v-icon>
        {{ item }}
        <span v-if="index < amenities.length - 1" class="font-weight-black"
          >·</span
        >
      </span>
    </div>
    <div v-else class="listing-amenities-details text">
      <v-row class="ma-0">
        <v-col v-for="item in amenities" :key="item" cols="6" :sm="4">
          <v-icon small class="mr-2 blue-grey--text">{{
            getAmenityIcon(item)
          }}</v-icon>
          <span color="blue-grey lighten-1">{{ item }}</span>
        </v-col>
      </v-row>
      <v-btn
        v-if="items.length > limit"
        class="text-capitalize mt-8"
        outlined
        @click="expanded = !expanded"
      >
        <span v-if="expanded">{{ $t("hide") }}</span>
        <span v-else>{{
          $t("view_all_amenities", { count: amenitiesCount })
        }}</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { AMENITY_ICONS, AMENITIES_DEFAULTS } from "@/consts/AMENITIES";

export default {
  name: "listing-amenities",
  props: {
    items: {
      type: Array,
      required: true,
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    limit: 10,
    expanded: false,
  }),
  computed: {
    amenities() {
      const list = this.expanded ? this.items : this.items.slice(0, this.limit);
      return list.map((item) => {
        const normalizedItem = AMENITIES_DEFAULTS[item] || item;
        return this.translateAmenity(normalizedItem);
      });
    },
    amenitiesCount() {
      return Object.keys(this.items).length;
    },
  },
  methods: {
    getAmenityIcon(amenity) {
      return (
        AMENITY_ICONS[amenity] ||
        AMENITY_ICONS[amenity.toLowerCase()] ||
        AMENITY_ICONS.default
      );
    },
    translateAmenity(amenity) {
      // Convert amenity name to translation key format
      const key = `amenity_${amenity
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_|_$/g, "")}`;

      // Try to get translation, fallback to original amenity name
      const translation = this.$t(key);
      return translation !== key ? translation : amenity;
    },
  },
};
</script>

<style lang="scss" scoped>
.listing-amenities {
  &-brief {
    .v-icon {
      font-size: 14px;
      vertical-align: middle;
    }
  }

  &-details {
    .v-icon {
      vertical-align: middle;
    }
  }
}
</style>
